import { Action, Reducer } from "redux";
import { AppThunkAction } from ".";
import { Get } from "../api/apiUtils";
import {
  ApiCallModel,
  LineHandling,
  Nomination,
  TruckNomination,
} from "../models";
import { PersistentDataService } from "../services/PersistentDataService";
import { SetActiveConfigAction } from "./ProcessFlowConfigStore";

export interface TruckNominationState {
  truckNomination: ApiCallModel<TruckNomination>;
  selectedState: string | undefined;
}

export const defaultState = {
  truckNomination: { isError: false, isLoading: false, result: undefined },
  selectedState: undefined,
} as TruckNominationState;

export interface SetNominationAction {
  type: "SET_TRUCK_NOMINATION";
  payload: ApiCallModel<TruckNomination>;
}

export interface SetSelectedStateAction {
  type: "SET_TRUCK_SELECTED_STATE";
  state: string;
}

type KnownAction = SetNominationAction | SetSelectedStateAction;

export const actionCreators = {
  getTruckNomination:
    (
      nominationNo: string | undefined,
      cacheFirst: boolean,
      retainState: boolean = false,
      success?: (() => void) | undefined
    ): AppThunkAction<
      SetSelectedStateAction | SetNominationAction | SetActiveConfigAction
    > =>
    (dispatch, getState) => {
      const state = getState();
      dispatch({
        type: "SET_TRUCK_SELECTED_STATE",
        state: "",
      });
      dispatch({
        type: "SET_TRUCK_NOMINATION",
        payload: {
          isLoading: true,
          isError: false,
          result: undefined,
        },
      });

      Get(`api/nomination/${nominationNo}`, cacheFirst)
        .then((response) => response.json())
        .then((result: TruckNomination) => {
          dispatch({
            type: "SET_TRUCK_NOMINATION",
            payload: {
              isLoading: false,
              isError: false,
              result,
            },
          });

          if (success) success();
          if (result.currentState && !retainState) {
            dispatch({
              type: "SET_TRUCK_SELECTED_STATE",
              state: result.currentState,
            });
          }

          var config =
            state.processFlowConfigState.processFlowConfigs.result &&
            state.processFlowConfigState.processFlowConfigs.result.find(
              (f) =>
                f.id === result.processFlowConfigId &&
                f.version === result.processFlowConfigVersion
            );
          dispatch({ type: "SET_ACTIVE_CONFIG", payload: config });
        })
        .catch((reason) =>
          dispatch({
            type: "SET_TRUCK_NOMINATION",
            payload: { isError: true, isLoading: false, result: undefined },
          })
        );
    },
  setTruckNomination: (nomination: TruckNomination) => ({
    type: "SET_TRUCK_NOMINATION",
    payload: { isLoading: false, isError: false, result: nomination },
  }),
  deleteActiveNomination: () => ({
    type: "SET_TRUCK_NOMINATION",
    payload: { isError: false, isLoading: false, result: undefined },
  }),
  setSelectedState: (state: string) => ({
    type: "SET_TRUCK_SELECTED_STATE",
    state,
  }),
};

export const reducers: Reducer<TruckNominationState> = (
  state: TruckNominationState | undefined,
  incomingAction: Action
): TruckNominationState => {
  if (state === undefined) {
    return defaultState;
  }

  const action = incomingAction as KnownAction;
  switch (action.type) {
    case "SET_TRUCK_NOMINATION":
      //   if (action.payload.result) {
      //     PersistentDataService.saveLineHandling(action.payload.result);
      //   }
      return { ...state, truckNomination: action.payload };
    case "SET_TRUCK_SELECTED_STATE":
      return { ...state, selectedState: action.state };
    default:
      return state;
  }
};
